import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { useApiConfig, useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { parseCTUpsellData } from '../../../utils/parse-ct-upsell-data.js';
import { UpsellItemContainer } from './UpsellItemContainer.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';

const UpsellCategoryContainer = ({ categoryKey  })=>{
    const { productsUrl  } = useApiConfig();
    const { staticsUrl  } = useCartSettings();
    const { getLabel , locale  } = useIntl();
    const { isBynderImagesEnabled , isProductLabelEnabled  } = useFeatureToggles();
    const [upsellProducts, setUpsellProducts] = React.useState([]);
    /**
   * Fetch and parse upsell products for a given category key.
   */ let cancelled = false;
    React.useEffect(()=>{
        const fetchUpsellProducts = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                try {
                    const { results  } = yield Products.query(productsUrl, {
                        categoryType: categoryKey
                    });
                    if (cancelled) {
                        return;
                    }
                    const parsedProducts = parseCTUpsellData(results, locale, staticsUrl, getLabel, isBynderImagesEnabled, isProductLabelEnabled);
                    setUpsellProducts(parsedProducts);
                } catch (e) {
                    console.error(`Error fetching upsell products ${e.message}`);
                }
            });
            return function fetchUpsellProducts() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUpsellProducts();
        return ()=>{
            cancelled = true;
        };
    }, [
        productsUrl,
        categoryKey,
        setUpsellProducts
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, upsellProducts.map((product)=>/*#__PURE__*/ React.createElement(UpsellItemContainer, swcHelpers.extends({
            key: product.sku
        }, product))
    ));
};

export { UpsellCategoryContainer };
//# sourceMappingURL=UpsellCategoryContainer.js.map
